import React, {Component} from "react";
import {Link} from "react-router-dom";
import './SubjectButton.css';

export class SubjectButton extends Component {
    render() {
        let {children, url, text, title} = this.props;
        let textElement = text ? <p>{text}</p> : null;
        return (
            <Link to={url} className="subjectButton p-1">
                <button className="btn-primary rounded btn-block w-100">
                    <h5>
                        {title}
                    </h5>
                    {textElement}
                    {children}
                </button>
            </Link>
        );
    }
}